/**
 * InteractiveGuide container
 * Using BNA-ICF mapping logic to get ICF id list, fetch ICF content, and render ICF list in the Recommend article section
 * Redirect to ICF Guide topics page, if clicking one of the ICF topic
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ICF_CONTENT, POPULAR_ARTICLE } from '../constants/PropTypesShapes';
import { icfClicked, guideClicked } from '../actions/action-icf-page';
import routeDidUpdate from '../actions/actions-router';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import l10n from '../../lib/reactPPl10nHelper';
import getHistory from '../../lib/HistoryHelper';
import Page from '../../lib/page';
import UrlResources from '../constants/UrlResources';
import { icfArticleUpdateContext } from '../../contactUs/actions/action-article';

const icf = {
  guide: {
    icfGuide: l10n.getContent('smarthelp/home.home.icf.guide'),
  },
};

class InteractiveGuideContainer extends Component {
  constructor(props) {
    super(props);
    this.icfClickHandler = this.icfClickHandler.bind(this);
    this.renderICFArticle = this.renderICFArticle.bind(this);
  }

  keyPressHandler(event, article) {
    if (event.which === 13) {
      this.icfClickHandler(article);
    }
  }

  icfClickHandler(article) {
    const { articles } = this.props;

    // Update context call for icf articles
    icfArticleUpdateContext(article, articles);
    const icfUrl = Page.getFormattedUrlForArticle(article.icf_title, article.icf_id);
    trackLink({
      id: 'ICFGuide', link: `icf-guide|click|${article.icf_id}|${article.icf_title}`, name: 'homePage', hpid: article.icf_id,
    });
    this.props.icfClicked(article.icf_id);
    this.props.guideClicked(true);
    this.props.routeDidUpdate({ pathname: `/${UrlResources.PAYPALGUIDE}/${icfUrl}` });
    getHistory().push(`/${UrlResources.PAYPALGUIDE}/${icfUrl}`);
  }

  // Checking whether ICF content is existed or not
  hasICFList() {
    return Array.isArray(this.props.icfList) && this.props.icfList.length;
  }

  renderICFArticle(article, icfPosition) {
    if (!article || !article.icf_id || !article.icf_title || article.isHidden) {
      return null;
    }

    // FPTI for icfguides in home page
    trackPage({ id: 'ICFGuide', link: `smarthelp-home-icf-${icfPosition}`, hpid: article.icf_id });

    return (
      <li key={article.icf_id} className="interactive-guide-item">
        <div className="interactive-guide-item-header">
          <a // eslint-disable-line jsx-a11y/no-static-element-interactions
            className="interactive-guide-item-title"
            tabIndex="0"
            onKeyPress={(e) => this.keyPressHandler(e, article)}
            onClick={() => this.icfClickHandler(article)}
          >
            {article.icf_title}
          </a>
          <span className="interactive-guide-item-guide">{icf.guide.icfGuide}</span>
        </div>
        <div className="interactive-guide-item-content">{article.icf_summary}</div>
      </li>
    );
  }

  renderICFGuideList() {
    const { icfPosition } = this.props;
    return (
      <ul className="interactive-guide-list">
        {this.props.icfList.map((article) => this.renderICFArticle(article, icfPosition))}
      </ul>
    );
  }

  render() {
    if (!this.hasICFList()) {
      return null;
    }

    return (
      <div className="interactive-guide-container">
        {this.renderICFGuideList()}
      </div>
    );
  }
}

InteractiveGuideContainer.propTypes = {
  icfList: PropTypes.arrayOf(PropTypes.shape(ICF_CONTENT)),
  icfClicked: PropTypes.func.isRequired,
  routeDidUpdate: PropTypes.func.isRequired,
  guideClicked: PropTypes.func.isRequired,
  icfPosition: PropTypes.string.isRequired,
  articles: PropTypes.arrayOf(PropTypes.shape(POPULAR_ARTICLE)),
};

InteractiveGuideContainer.defaultProps = {
  isLoading: false,
  error: false,
  icfList: [],
  query: '',
};

function mapStateToProps(state) {
  return {
    isLoading: state.icfGuide.isLoading,
    error: state.icfGuide.error,
    icfList: state.icfGuide.icfList,
    query: state.icfGuide.query,
    articles: state.popular.articles,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ icfClicked, routeDidUpdate, guideClicked }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(InteractiveGuideContainer);
